"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const tslib_1 = require("tslib");
const react_1 = require("@osmosys/react");
const react_2 = tslib_1.__importDefault(require("react"));
const react_if_1 = require("react-if");
const index_1 = require("./Toolbar/index");
const SideBySideView_1 = require("./views/SideBySideView");
const PreviewView_1 = require("./views/PreviewView");
const EditorView_1 = require("./views/EditorView");
const TemplateView_1 = require("./views/TemplateView");
const CodeModePanel_1 = require("./panels/CodeModePanel");
const ConverterPanel_1 = require("./panels/ConverterPanel");
const NewView_1 = require("./views/NewView");
const CampaignSenderView_1 = require("./views/CampaignSenderView");
const ContentImportPanelOuter_1 = require("./ContentImportPanelOuter");
exports.EmailCanvasInnerDumb = ({ view, codeMode }) => {
    if (view === 'new') {
        return react_2.default.createElement(NewView_1.EmailCanvasNewView, null);
    }
    return (react_2.default.createElement(react_1.OsmosysFlexFrame, { osysName: "EmailCanvasInner.outer", className: "position-relative" },
        react_2.default.createElement(ContentImportPanelOuter_1.EmailCanvasContentImportPanelOuter, null),
        react_2.default.createElement(index_1.EmailCanvasToolbar, null),
        react_2.default.createElement(react_if_1.Switch, null,
            react_2.default.createElement(react_if_1.Case, { condition: view === 'sideBySide' }, () => react_2.default.createElement(SideBySideView_1.EmailCanvasSideBySideView, null)),
            react_2.default.createElement(react_if_1.Case, { condition: view === 'preview' }, () => react_2.default.createElement(PreviewView_1.EmailCanvasPreviewView, null)),
            react_2.default.createElement(react_if_1.Case, { condition: view === 'editor' }, () => (react_2.default.createElement(react_1.OsmosysFlexFrame.Row, { osysName: "EmailCanvasSideBySideView" },
                react_2.default.createElement(react_1.OsmosysFlexFrame.Col, { osysName: "EmailCanvasSideBySideView.Col" },
                    react_2.default.createElement(EditorView_1.EmailCanvasEditorView, null))))),
            react_2.default.createElement(react_if_1.Case, { condition: view === 'template' }, () => react_2.default.createElement(TemplateView_1.EmailCanvasTemplateView, null)),
            react_2.default.createElement(react_if_1.Case, { condition: view === 'send' }, () => react_2.default.createElement(CampaignSenderView_1.EmailCanvasCampaignSenderView, null)),
            react_2.default.createElement(react_if_1.Default, null, () => react_2.default.createElement(react_1.OsmosysUndesiredState, { message: "Not found" }))),
        react_2.default.createElement(react_if_1.When, { condition: !!codeMode }, () => react_2.default.createElement(CodeModePanel_1.EmailCanvasCodeModePanel, null)),
        react_2.default.createElement(ConverterPanel_1.EmailCanvasConverterPanel, null),
        react_2.default.createElement(react_1.OsmosysDiv, { id: "emailCanvas-sidebar-portal", osysName: "emailCanvas-sidebar", className: "overflow-hidden", style: {
                bottom: 0,
                maxWidth: 350,
                position: 'absolute',
                right: 0,
                top: 0,
                zIndex: 1,
            }, flexCol: true })));
};
//# sourceMappingURL=InnerDumb.js.map